const UploadRow = ({
  id = "upload",
  icon,
  text = "Upload your photo",
  buttonText = "Upload",
  accept = "image/*",
  multiple = false, 
  onChange,
}) => {
  return (
    <div className="border-2 border-dashed border-orange-400 rounded-xl px-6 w-full py-4 bg-[#FFEFEB]">
      <div className="flex items-center justify-between gap-4">
        
        {/* Left: Icon + Text */}
        <div className="flex items-center gap-3">
          <div className="bg-[#FFD8CE] rounded-full h-12 w-12 flex items-center justify-center">
            <img src={icon} alt="upload_icon" className="h-6 w-6" />
          </div>

          <p className="text-sm text-gray-600">{text}</p>
        </div>

        {/* Right: Button */}
        <label
          htmlFor={id}
          className="px-5 py-2 rounded-3xl text-white text-sm bg-[#FF6943] cursor-pointer hover:opacity-90 transition whitespace-nowrap"
        >
          {buttonText}
        </label>

        {/* Hidden Input */}
        <input
          id={id}
          type="file"
          accept={accept}
          multiple={multiple}
          onChange={onChange}
          className="hidden"
        />
      </div>
    </div>
  );
};

export default UploadRow;
